export default "__VITE_ASSET__DOtEtpn$__"